/**
 * Complete table filters data for POST request with all required fields
 * @param {Partial<ApiManagerTableFiltersCreate>} partialData - Partial data from handler
 * @param {ApiManagerTableFilters | undefined} currentFilters - Current table filters from GET
 * @returns {ApiManagerTableFiltersCreate} Complete data with all required fields
 */
export const completeTableFiltersForPost = (partialData, currentFilters) => ({
  columnFilters: partialData?.columnFilters ?? currentFilters?.columnFilters ?? [],
  sortBy: {
    id: partialData?.sortBy?.id ?? currentFilters?.sortBy?.id ?? '',
    criteriaValues: partialData?.sortBy?.criteriaValues ?? currentFilters?.sortBy?.criteriaValues ?? [],
  },
  filterValues: partialData?.filterValues ?? currentFilters?.filterValues ?? [],
  groupBy: {
    selectedOption: partialData?.groupBy?.selectedOption ?? currentFilters?.groupBy?.selectedOption ?? null,
  },
  search: {
    // Normalize null to []: the GET may return null for selectedOptions, but the POST requires an array (not null)
    // Using ?? alone doesn't work because null ?? [] still returns null (?? only handles null/undefined on the left side)
    selectedOptions: (() => {
      const value = partialData?.search?.selectedOptions ?? currentFilters?.search?.selectedOptions;
      if (!Array.isArray(value)) return [];
      return value.filter((item) => item != null);
    })(),
    searchValue: partialData?.search?.searchValue ?? currentFilters?.search?.searchValue ?? '',
  },
  pageSize: partialData?.pageSize ?? currentFilters?.pageSize ?? '25',
  personalViews: {
    selectedOption: partialData?.personalViews?.selectedOption ?? null,
  },
});
